import { render, staticRenderFns } from "./TableReviewSystemCategory.vue?vue&type=template&id=81cd91a8"
import script from "./TableReviewSystemCategory.vue?vue&type=script&lang=js"
export * from "./TableReviewSystemCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports